import { yupResolver } from "@hookform/resolvers/yup";
import {
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import FormWrapper from "src/components/FormWrapper";
import Iconify from "src/components/Iconify";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import { restrict } from "src/components/restrict";
import { updateInventory } from "src/pages/api";

import * as Yup from "yup";

const defaultArrayProduct = {
  productID: "",
  qty: "",
  productName: "",
  quantity: "",
};

const defaultValues = {
  products: [defaultArrayProduct],
};

const productSchema = Yup.object().shape({
  qty: Yup.number()
    .nullable()
    .typeError("Required")
    .required("required")
    .min(1, "Minimum Value should be 1"),
});

const schema = Yup.object().shape({
  products: Yup.array().of(productSchema).min(1, "Minimum 1"),
});
export default function AddPurchaseOrder({ onClose, row }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });
  const { handleSubmit, reset, control } = methods;

  const { fields, append, remove } = useFieldArray({
    name: "products",
    control,
  });

  const mutation = useMutation(req => updateInventory({ req }), {
    onSuccess: () => {
      enqueueSnackbar("Order Updated", {
        variant: "success",
      });
      queryClient.invalidateQueries(["draftOrder"]);

      onClose();
    },
    onError: error => {
      enqueueSnackbar(error?.message || "Failed to update order", {
        variant: "error",
      });
    },
  });

  const onSubmit = data => {
    const req = {
      products: data.products.map(el => ({
        productID: el.productID,
        qty: +el.qty,
      })),
    };

    mutation.mutate(req);
  };

  useEffect(() => {
    if (row) {
      const filterPendingItems = row.orderDetails.filter(
        el => el.receivedQuantity !== el.quantity
      );
      reset({ products: filterPendingItems });
    }
  }, [row]);

  return (
    <FormWrapper
      onClose={onClose}
      onSubmit={handleSubmit(onSubmit)}
      loading={mutation.isLoading}
      maxWidth={"md"}
      fullWidth
      fullScreen
      title={"Update Order"}
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <TableContainer>
          {loading && <LinearProgress />}
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell width={70}>Sr. No.</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Requested Qty</TableCell>
                <TableCell>Received Qty</TableCell>
                <TableCell>Qty</TableCell>

                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <RHFTextField
                      name={`products.${index}.productName`}
                      // label=""
                      placeholder="ISBN"
                      size="small"
                      inputProps={{
                        readOnly: true,
                        style: {
                          backgroundColor: "#f5f5f5",
                          color: "rgba(0, 0, 0, 0.38)", 
                          cursor: "default",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <RHFTextField
                      name={`products.${index}.quantity`}
                      // label=""
                      placeholder="ISBN"
                      size="small"
                      inputProps={{
                        readOnly: true,
                        style: {
                          backgroundColor: "#f5f5f5",
                          color: "rgba(0, 0, 0, 0.38)", 
                          cursor: "default",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <RHFTextField
                      name={`products.${index}.receivedQuantity`}
                      // label=""
                      placeholder="ISBN"
                      size="small"
                      inputProps={{
                        readOnly: true,
                        style: {
                          backgroundColor: "#f5f5f5",
                          color: "rgba(0, 0, 0, 0.38)", 
                          cursor: "default",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <RHFTextField
                      name={`products.${index}.qty`}
                      label="Qty"
                      size="small"
                      inputProps={{ maxLength: 5 }}
                      onInput={restrict.digits}
                    />
                  </TableCell>

                  <TableCell>
                    <IconButton
                      size="small"
                      color="error"
                      title="Delete"
                      onClick={() => {
                        remove(index);
                      }}
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </FormProvider>
    </FormWrapper>
  );
}
